import { useParams, useSearchParams } from 'react-router';
export var MarketplaceIds;
(function (MarketplaceIds) {
    MarketplaceIds["US"] = "US";
    MarketplaceIds["CA"] = "CA";
    MarketplaceIds["ES"] = "ES";
    MarketplaceIds["FR"] = "FR";
    MarketplaceIds["IT"] = "IT";
    MarketplaceIds["DE"] = "DE";
    MarketplaceIds["UK"] = "UK";
})(MarketplaceIds || (MarketplaceIds = {}));
export const amazonSiteByMarketplace = {
    [MarketplaceIds.US]: 'https://www.amazon.com',
    [MarketplaceIds.CA]: 'https://www.amazon.ca',
    [MarketplaceIds.ES]: 'https://www.amazon.es',
    [MarketplaceIds.FR]: 'https://www.amazon.fr',
    [MarketplaceIds.IT]: 'https://www.amazon.it',
    [MarketplaceIds.DE]: 'https://www.amazon.de',
    [MarketplaceIds.UK]: 'https://www.amazon.co.uk',
};
export var RetailRoutes;
(function (RetailRoutes) {
    RetailRoutes["VIEW_CART"] = "VIEW_CART";
    RetailRoutes["ORDER_HISTORY"] = "ORDER_HISTORY";
    RetailRoutes["ADDRESS_LIST"] = "ADDRESS_LIST";
    RetailRoutes["CONDITIONS_OF_USE"] = "CONDITIONS_OF_USE";
    RetailRoutes["PRIVACY_NOTICE"] = "PRIVACY_NOTICE";
    RetailRoutes["RETURN_POLICY"] = "RETURN_POLICY";
    RetailRoutes["PAYMENT_SELECTION_WALLET"] = "PAYMENT_SELECTION_WALLET";
    RetailRoutes["DETAIL_PAGE"] = "DETAIL_PAGE";
})(RetailRoutes || (RetailRoutes = {}));
const redirectRoutes = {
    [RetailRoutes.VIEW_CART]: '/gp/cart/view.html',
    [RetailRoutes.ORDER_HISTORY]: '/gp/your-account/order-history',
    [RetailRoutes.ADDRESS_LIST]: '/a/addresses',
    [RetailRoutes.CONDITIONS_OF_USE]: '/gp/help/customer/display.html?nodeId=GLSBYFE9MGKKQXXM',
    [RetailRoutes.PRIVACY_NOTICE]: '/gp/help/customer/display.html?nodeId=GX7NJQ4ZB8MHFRNJ',
    [RetailRoutes.RETURN_POLICY]: '/gp/help/customer/display.html?nodeId=GKM69DUUYKQWKWX7',
    [RetailRoutes.PAYMENT_SELECTION_WALLET]: '/cpe/yourpayments/wallet',
    [RetailRoutes.DETAIL_PAGE]: '/dp',
};
export const useRetailRedirectUrls = (routes, providedAsin) => {
    const [searchParams] = useSearchParams();
    const { asin: asinFromPath } = useParams();
    const asin = providedAsin || asinFromPath;
    const marketplaceId = searchParams.get('marketplaceId') || MarketplaceIds.US;
    const baseUrl = amazonSiteByMarketplace[marketplaceId] || amazonSiteByMarketplace[MarketplaceIds.US];
    return routes.reduce((obj, route) => {
        let finalUrl = `${baseUrl}${redirectRoutes[route]}`;
        if (route === RetailRoutes.DETAIL_PAGE) {
            finalUrl = asin ? `${finalUrl}/${asin}` : baseUrl;
        }
        obj[route] = appendRequestQueryParams(searchParams, finalUrl);
        return obj;
    }, {});
};
// Appends query params to the given URL.
export const appendRequestQueryParams = (searchParams, initialUrl) => {
    const url = new URL(initialUrl);
    const finalSearchParams = url.searchParams;
    // Overwrite or add existing query params to the initialUrl
    searchParams.forEach((value, key) => {
        finalSearchParams.set(key, value);
    });
    return url.href;
};
